// Messages métier (mêmes codes que teqa_store, garder les deux fichiers alignés ;
// ici en anglais, langue de l'app confirmation). Traduit les "code" renvoyés par les services
// marketplace / integration / delivery en phrases claires pour l'utilisateur.

const CONFLICT_REASONS = {
  SOURCE_ALREADY_COVERED: "this shop is already fully assigned to another agent or agency",
  SOURCE_HAS_PRODUCT_ASSIGNMENTS: "products of this shop are already assigned to another agent or agency",
  SOURCE_ALREADY_ASSIGNED_COMPLETELY: "this shop is already fully assigned to another agent or agency",
  PRODUCT_ALREADY_ASSIGNED: "this product is already assigned to another agent or agency",
};

const EXACT = {
  // affectations / collaborations
  ASSIGNMENT_CONFLICT:
    "Assignment not possible: these orders are already handled by another confirmation agent or agency.",
  ORDER_ALREADY_ASSIGNED:
    "This order is already assigned to another agent or agency. Use “Move” to reassign it.",
  ORDER_COVERED_BY_COLLABORATION:
    "This order is already handled automatically by another agent or agency (assigned shop or product).",
  // livraison
  NO_CONNECTION: "No delivery account connected for this company. Connect it in Delivery > Companies.",
  CONNECTION_NOT_FOUND: "This delivery account no longer exists or has been disabled.",
  INCOMPLETE_CONNECTION: "The credentials of this delivery account are incomplete.",
  AGENCY_NOT_CONFIGURED: "This delivery company is not enabled on the platform yet.",
  AGENCY_DISABLED: "This delivery company is disabled on the platform.",
  NOT_SUPPORTED: "This action is not offered by this delivery company.",
  IN_PROGRESS: "A shipment is already in progress for this order. Please wait a few seconds.",
  UNCONFIRMED:
    "The company may have already created this parcel. Check your carrier account before trying again.",
  CONFIRMATION_REQUIRED: "This action changes the parcel immediately: confirm to continue.",
};

const SUFFIX = {
  _AUTH_FAILED: "Credentials rejected by the delivery company. Check the API key of the connected account.",
  _TIMEOUT: "The delivery company is not responding. Try again in a moment.",
  _UNREACHABLE: "Unable to reach the delivery company. Try again later.",
  _UNAVAILABLE: "The delivery company is temporarily unavailable.",
  _RATE_LIMITED: "Too many requests sent to the company. Please wait a minute.",
  _NOT_FOUND: "Parcel or resource not found at the delivery company.",
  _INVALID_RESPONSE: "Unexpected response from the delivery company. Check the parcel in your carrier account.",
};

/** Message métier pour une erreur axios, ou null si le code n'est pas connu. */
export function businessErrorMessage(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") return null;
  const code = String(data.code || "").toUpperCase();

  if (code === "ASSIGNMENT_CONFLICT" && Array.isArray(data.conflicts) && data.conflicts.length) {
    const reasons = [...new Set(data.conflicts.map((c) => CONFLICT_REASONS[c.reason]).filter(Boolean))];
    if (reasons.length) return `Affectation impossible : ${reasons.join(" ; ")}.`;
  }
  if (EXACT[code]) {
    // le détail de l'agence (ex. "Ville invalide") est plus précis que le message générique
    return code === "NOT_SUPPORTED" || code === "NO_CONNECTION" ? data.detail || EXACT[code] : EXACT[code];
  }
  const suffix = Object.keys(SUFFIX).find((s) => code.endsWith(s));
  if (suffix) {
    const detail = typeof data.detail === "string" ? data.detail : "";
    return detail && suffix !== "_AUTH_FAILED" ? detail : SUFFIX[suffix];
  }
  if (code.endsWith("_REJECTED") && data.detail) return String(data.detail);
  return null;
}

/** Premier message d'erreur de champ ({"phone": ["..."]}) -> "phone : ...". */
export function fieldErrorMessage(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") return null;
  const entry = Object.entries(data).find(
    ([key, value]) => !["detail", "code", "conflicts"].includes(key) && (Array.isArray(value) || typeof value === "string")
  );
  if (!entry) return null;
  const [field, value] = entry;
  return `${field.replaceAll("_", " ")} : ${Array.isArray(value) ? value.join(" ") : value}`;
}
